import type {ApiError} from 'fast-sdk/src/requests';
import {getOrganizationMembersDetails} from 'interface/stacks/auth/consts';
import {useState} from 'react';
import {useDispatch} from 'react-redux';
import * as user from 'store/slices/user';

export function useFetchOrgMembers() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<ApiError | undefined>(undefined);

  const getMembers = async (domain: string, id: string) => {
    setLoading(true);
    try {
      const {members, error} = await getOrganizationMembersDetails(domain);
      if (error) {
        setError(error);
      } else {
        dispatch(
          user.default.actions.setMembersByOrganization({
            organizationId: id,
            members,
          }),
        );
      }
      return members;
    } finally {
      setLoading(false);
    }
  };

  return {getMembers, loading, error};
}
